import { render, staticRenderFns } from "./render-cost-config-tab.vue?vue&type=template&id=4c8e85d1&scoped=true"
import script from "./render-cost-config-tab.vue?vue&type=script&lang=js"
export * from "./render-cost-config-tab.vue?vue&type=script&lang=js"
import style0 from "./render-cost-config-tab.vue?vue&type=style&index=0&id=4c8e85d1&prod&scoped=true&lang=css"
import style1 from "./render-cost-config-tab.vue?vue&type=style&index=1&id=4c8e85d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e85d1",
  null
  
)

export default component.exports